// Copyright (c) 2021 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { history } from 'api/helpers/history'
import App from 'app'
import Login from 'components/Auth/Login'
import ApplicationError from 'components/Utilities/ApplicationError'
import ApplicationLoading from 'components/Utilities/ApplicationLoading'
import ForbiddenError from 'components/Utilities/ForbiddenError'
import ServerError from 'components/Utilities/ServerError'
import Gallery from 'pages/Gallery/Gallery'
import document from 'global/document'
import 'react-awesome-query-builder/lib/css/compact_styles.css'
import 'react-awesome-query-builder/lib/css/styles.css'
import { render } from 'react-dom'
import 'react-rangeslider/lib/index.css'
import { Provider } from 'react-redux'
import { Redirect, Route, Router, Switch } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import store from 'store/index'
import 'styles/plugins/ReactToastify.css'
// eslint-disable-next-line absolute-import/no-relative-path
import './styles/app.css'
// eslint-disable-next-line absolute-import/no-relative-path
import './styles/tailwind.css'

// const AsyncLoginPage = loadable(() => import('components/LoginPage/LoginPage'))

window.toast = toast
const Root = () => (
  <Provider store={store}>
    <ApplicationLoading />
    <ApplicationError />
    <ServerError />
    <ForbiddenError />

    <ToastContainer autoClose={5000} />
    <Router history={history}>
      <Switch>
        <Route exact path='/public-map/:code' component={App} />
        <Route exact path='/map/:code' component={App} />
        <Route exact path='/maps' component={App} />
        <Route exact path='/gallery' component={Gallery} />
        <Route exact path='/' component={Login} />
        <Route exact path='/login' component={Login} />

        <Redirect from='*' to='/' />
      </Switch>
    </Router>
  </Provider>
)

render(<Root />, document.getElementById('root'))
